<app-schedule-layout [ctx]="ctx"></app-schedule-layout>
